module.exports = __webpack_public_path__ + "fonts/Inter-300-latin-ext41.1ad231a.woff2";